// extracted by mini-css-extract-plugin
module.exports = {"edit_title":"index_edit_title__3bp8K","body_one_edit":"index_body_one_edit__2AAti","footer_con_edit":"index_footer_con_edit__1sNZz"};